import { render } from "./BaseCustomDropdownOptions.vue?vue&type=template&id=9321b1a6&scoped=true&ts=true"
import script from "./BaseCustomDropdownOptions.vue?vue&type=script&lang=ts"
export * from "./BaseCustomDropdownOptions.vue?vue&type=script&lang=ts"

import "./BaseCustomDropdownOptions.vue?vue&type=style&index=0&id=9321b1a6&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9321b1a6"]])

export default __exports__